// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3162":"834567ce","3795":"88f3b24f","4338":"d9ffc902","5666":"bd1b95b2","7508":"8a372c7d","9437":"cc72ad56"}[chunkId] + ".chunk.css";
};